if (!customElements.get('how-custom-works')) {
  const HOW_CUSTOM_SCROLL_PER_STEP = 250;

  class HowCustomWorks extends HTMLElement {
    connectedCallback() {
      this.pin = this.querySelector('.how-custom__pin');
      this.stepsEls = this.querySelectorAll('[data-step-index]');
      this.steps = Number(this.dataset.steps) || 1;
      this.activeIndex = -1;
      this.ticking = false;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      // Desktop advances on scroll (pinned stage); mobile has no pin, so the
      // client wants the numbered steps to switch on tap instead.
      this.desktop = window.matchMedia('(min-width: 750px)');

      for (const el of this.stepsEls) {
        const index = Number(el.dataset.stepIndex);
        el.addEventListener('click', () => {
          if (!this.desktop.matches) this.setStep(index);
        });
        el.addEventListener('keydown', (event) => {
          if (this.desktop.matches) return;
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            this.setStep(index);
          }
        });
      }

      if (this.reducedMotion || this.steps < 2) {
        this.classList.add('is-static');
        this.setStep(0);
        return;
      }

      this.onScroll = () => {
        if (this.ticking) return;
        this.ticking = true;
        requestAnimationFrame(() => {
          this.updateFromScroll();
          this.ticking = false;
        });
      };

      this.syncMode = () => {
        const isDesktop = this.desktop.matches;
        for (const el of this.stepsEls) {
          if (isDesktop) {
            el.removeAttribute('tabindex');
            el.removeAttribute('role');
          } else {
            el.setAttribute('tabindex', '0');
            el.setAttribute('role', 'button');
          }
        }
        if (isDesktop) {
          window.addEventListener('scroll', this.onScroll, { passive: true });
          window.addEventListener('resize', this.onScroll, { passive: true });
          this.updateFromScroll();
        } else {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
          if (this.activeIndex < 0) this.setStep(0);
        }
      };

      this.desktop.addEventListener('change', this.syncMode);
      this.syncMode();
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      this.desktop?.removeEventListener('change', this.syncMode);
    }

    updateFromScroll() {
      if (!this.pin) return;

      const scrollPerStep = HOW_CUSTOM_SCROLL_PER_STEP;
      const travel = scrollPerStep * Math.max(this.steps - 1, 1);
      const rect = this.pin.getBoundingClientRect();
      const scrolled = Math.min(Math.max(-rect.top, 0), travel);
      const index = Math.min(this.steps - 1, Math.floor((scrolled + 1) / scrollPerStep));
      this.setStep(index);
    }

    setStep(index) {
      if (index === this.activeIndex) return;
      this.activeIndex = index;
      this.style.setProperty('--how-custom-step', String(index));

      for (const el of this.stepsEls) {
        const isActive = Number(el.dataset.stepIndex) === index;
        el.classList.toggle('is-active', isActive);
        el.setAttribute('aria-current', isActive ? 'step' : 'false');
      }
    }
  }

  customElements.define('how-custom-works', HowCustomWorks);
}
